<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<h1 class="toc_head">Contents</h1>
<h2 class="toc"><a href="#/xhtml/05_Prologue"><em class="italic">Prologue</em></a></h2>
<h2 class="toc"><a href="#/xhtml/06_Chapter01"><span class="bold">Chapter 1</span><span class="space">London Bridge Fell Down</span></a></h2>
<h2 class="toc"><a href="#/xhtml/07_Chapter02"><span class="bold">Chapter 2</span><span class="space">‘Never was such an atrocity seen’</span></a></h2>
<h2 class="toc"><span href="#/xhtml/08_Chapter03" title="Link target outside of Sample"><span class="bold">Chapter 3</span><span class="space">The Precursors I: St Anskar to Athelstan</span></span></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter04" title="Link target outside of Sample"><span class="bold">Chapter 4</span><span class="space">The Precursors II: Hakon the Good and Olaf Tryggvason</span></span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter05" title="Link target outside of Sample"><span class="bold">Chapter 5</span><span class="space">Conversion and Conquest</span></span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter06" title="Link target outside of Sample"><span class="bold">Chapter 6</span><span class="space">Beware the Blinded Man</span></span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter07" title="Link target outside of Sample"><span class="bold">Chapter 7</span><span class="space">The Swedish Princess</span></span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter08" title="Link target outside of Sample"><span class="bold">Chapter 8</span><span class="space">‘Hit it as hard as you can’</span></span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter09" title="Link target outside of Sample"><span class="bold">Chapter 9</span><span class="space">Cnut’s Gold Ring</span></span></h2>
<h2 class="toc"><span href="#/xhtml/15_Chapter10" title="Link target outside of Sample"><span class="bold">Chapter 10</span><span class="space">The Last Battle</span></span></h2>
<h2 class="toc"><span href="#/xhtml/16_Chapter11" title="Link target outside of Sample"><span class="bold">Chapter 11</span><span class="space">The Saint</span></span></h2>
<h2 class="toc"><span href="#/xhtml/17_Chapter12" title="Link target outside of Sample"><span class="bold">Chapter 12</span><span class="space">Mission Accomplished</span></span></h2>
<h2 class="toc"><span href="#/xhtml/18_Epilogue" title="Link target outside of Sample"><em class="italic">Epilogue: Where is he now?</em></span></h2>
<h2 class="toci"><span href="#/xhtml/19_Note" title="Link target outside of Sample"><em class="italic">Bibliographical Note</em></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?0dfd7eda